import { useContext } from 'react';
import DialogContext from '../contexts/DialogContext';

export const useDialogDispatcher = () => {
  const { showDialog, hideDialog } = useContext(DialogContext);
  return { showDialog, hideDialog };
};
